export type CanvasRect = { x: number; y: number; w: number; h: number };

const pickPositiveNumber = (...values: Array<unknown>): number | undefined => {
  for (const value of values) {
    if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
      return value;
    }
  }
  return undefined;
};

const pickFiniteNumber = (...values: Array<unknown>): number | undefined => {
  for (const value of values) {
    if (typeof value === 'number' && Number.isFinite(value)) {
      return value;
    }
  }
  return undefined;
};

export const getGenogramPersonSymbolRect = (
  node: unknown,
  fallback?: Partial<CanvasRect>,
): CanvasRect | null => {
  const record = node as Record<string, unknown> | null | undefined;
  if (!record || record.type !== 'person') return null;

  const attrs =
    typeof record.attrs === 'object' && record.attrs !== null
      ? (record.attrs as Record<string, unknown>)
      : {};

  const width = pickPositiveNumber(record.w, record.width, attrs.w, attrs.width, fallback?.w) ?? 60;
  const height = pickPositiveNumber(record.h, record.height, attrs.h, attrs.height, fallback?.h) ?? 60;
  const size = Math.max(1, Math.min(width, height));

  return {
    x: pickFiniteNumber(record.x, fallback?.x) ?? 0,
    y: pickFiniteNumber(record.y, fallback?.y) ?? 0,
    w: size,
    h: size,
  };
};
